import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';

interface LoadingSpinnerProps {
    size?: 'sm' | 'md' | 'lg';
    className?: string;
    label?: string;
}

const SIZES = {
    sm: 'h-4 w-4',
    md: 'h-6 w-6',
    lg: 'h-10 w-10',
};

export function LoadingSpinner({ size = 'md', className, label }: LoadingSpinnerProps) {
    return (
        <div className={cn('flex items-center gap-2', className)} role="status">
            <Loader2 className={cn('animate-spin text-muted-foreground', SIZES[size])} />
            {label && <span className="text-sm text-muted-foreground">{label}</span>}
            <span className="sr-only">{label ?? 'Loading...'}</span>
        </div>
    );
}

export function FullPageLoader({ label = 'Loading...' }: { label?: string }) {
    return (
        <div className="flex flex-col items-center justify-center min-h-[60vh]">
            <LoadingSpinner size="lg" />
            <p className="mt-4 text-sm text-muted-foreground">{label}</p>
        </div>
    );
}

export function InlineLoader({ label }: { label?: string }) {
    return (
        <div className="flex items-center justify-center py-8">
            <LoadingSpinner size="md" label={label} />
        </div>
    );
}

// Button loading state helper
export function ButtonSpinner() {
    return <Loader2 className="h-4 w-4 animate-spin mr-2" />;
}